import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getCustomerToken, customerApi } from "../../api/client";

/** Schedules `/browse-followup/register` processed after SITE_CLOSE_FOLLOWUP_MINUTES (default 2) on API. */
function registerBrowseFollowup(pathname) {
  const token = getCustomerToken();
  if (!token) return;
  customerApi("/api/customer/browse-followup/register", {
    method: "POST",
    body: JSON.stringify({ pathname: pathname || "/" }),
  }).catch(() => {});
}

/**
 * Logged-in only. On real page unload (`pagehide`, not BFCache restore), queues a gentle
 * “still looking?” email unless the cart has items (then cart abandonment handles it) or route is excluded.
 */
export default function BrowseCloseFollowUp() {
  const location = useLocation();
  const pathnameRef = useRef(location.pathname);
  const cartItemCount = useSelector((s) => s.cart.items.length);

  useEffect(() => {
    pathnameRef.current = location.pathname;
  }, [location.pathname]);

  useEffect(() => {
    const onPageHide = (ev) => {
      if (ev.persisted) return;
      const path = pathnameRef.current || "/";
      if (!getCustomerToken()) return;
      if (path.startsWith("/admin")) return;
      if (path === "/payment/success" || path === "/payment") return;
      if (cartItemCount > 0) return;
      registerBrowseFollowup(path);
    };

    window.addEventListener("pagehide", onPageHide);
    return () => window.removeEventListener("pagehide", onPageHide);
  }, [cartItemCount]);

  return null;
}
